import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import {Driver, FarmOut, User, Vehicle, VehicleCategory} from '../../models/business-objects';
import {AuthService} from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  UrlAPI: string = environment.apiURL;
  public currentUser: User;
  subscriptions = [];
  private _currentVehicles: BehaviorSubject<Vehicle[]>;
  private _currentDrivers: BehaviorSubject<Driver[]>;
  constructor(private http: HttpClient, private authService: AuthService) {
    this.subscriptions.push(authService.currentUser.subscribe( user =>  {
      this.currentUser = user
      if (this.currentUser != null && this.currentUser.proveedorId != null ) {
        this.initializeLists().then( data => {});
      }
    }));
    this._currentVehicles = new BehaviorSubject<Vehicle[]>(null);
    this._currentDrivers = new BehaviorSubject<Driver[]>(null);
  }
  public get currentVehicles(): Vehicle[] {
    return this._currentVehicles.value != null ?  this._currentVehicles.value : [];
  }
  public set currentVehicles(vehicles: Vehicle[]) {
    this._currentVehicles.next(vehicles);
  }
  public get currentDrivers(): Driver[] {
    return this._currentDrivers.value != null ?  this._currentDrivers.value : [];
  }
  public set currentDrivers(drivers: Driver[]) {
    this._currentDrivers.next(drivers);
  }

  async initializeLists(): Promise<boolean> {
    console.log('initialing list vehicles');
    try {
      if (this.authService.currentUserValue != null && this.authService.currentUserValue.proveedorId != null) {
        this.currentVehicles = await this.getVehiclesFromAPI();
        this.currentDrivers = await this.getDriversFromAPI();
        this.currentVehicles = this.currentVehicles.sort((a, b) => a.plate.localeCompare(b.plate));
        console.log('vehicles for user should be ready : '
          + (this._currentVehicles != null ? this._currentVehicles.value.length : 'null'));
        // console.log(this.currentVehiclesSubject.value);
        this.currentDrivers = this.currentDrivers.sort((a, b) => (a.firstName??"").localeCompare((b.firstName??"")) || (a.lastName??"").localeCompare((b.lastName??"")));
        console.log('drivers for user should be ready: ' + (this._currentDrivers != null ? this._currentDrivers.value.length : 'null'));
        // console.log(this.currentCategoriesSubject.value);
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.log(err);
      console.log('vehicles or categories list failed !');
      return false;
    }
  }


  getServiceToConfirm(jwt: string): Promise<any> { // devuelve un objeto con Job y User
    const urlFinal = environment.URL_FARMOUT_TO_CONFIRM_POR_JWT;
    let headers = new HttpHeaders();
    const body = { jwt };
    console.log('Reserva solicitada con jwt ' + jwt);
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }
  getServiceToConfirmById(farmOutId: number,diasAtras:string, diasAdelante: string, maxReservas: string,minReservas: string,soloConfirmadas: boolean,quitarHechas: boolean): Promise<any> { // devuelve un objeto con Job y User
    const urlFinal = environment.URL_SEARCH_FARMOUT;
    let headers = new HttpHeaders();
    const formatoFecha = 'yyyy/MM/dd';
    const body = farmOutId ? { farmOutId, diasAtras, diasAdelante, maxReservas,minReservas,soloConfirmadas,quitarHechas,formatoFecha}:{diasAtras, diasAdelante, maxReservas,minReservas,soloConfirmadas,quitarHechas,formatoFecha};
    console.log('Reserva solicitada con farmOutId ' + farmOutId);
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }
  getFarmoutUpdate(jwt: string, farmOut:FarmOut): Promise<any> { // devuelve un objeto con Job y User
    const urlFinal = environment.URL_UPDATE_FARMOUT;
    let headers = new HttpHeaders();
    const body = { jwt,farmOut };
    console.log('Reserva solicitada con jwt ' + jwt);
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }

  getVehiclesFromJWT(jwt : String) :Promise<Vehicle[]> {
    const urlFinal = environment.URL_VEHICULO_USUARIO;
    let headers = new HttpHeaders();
    const body = { jwt };
    console.log('Reserva solicitada con jwt ' + jwt);
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }
  getDriversFromJWT(jwt : String) : Promise<Driver[]> {
    const urlFinal = environment.URL_CONDUCTOR_USUARIO;
    let headers = new HttpHeaders();
    const body = { jwt };
    console.log('Reserva solicitada con jwt ' + jwt);
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }
  private async getVehiclesFromAPI(): Promise<Vehicle[]>  {
    const urlFinal = environment.URL_VEHICULO_USUARIO;
    let headers = new HttpHeaders();
    const body = { };
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers}));
  }

  private async getDriversFromAPI(): Promise<Driver[]>  {
    const urlFinal = environment.URL_CONDUCTOR_USUARIO;
    let headers = new HttpHeaders();
    const body = { };
    headers = headers.set('Accept', 'application/json');
    return firstValueFrom(this.http.post<any>(this.UrlAPI + urlFinal, body, {headers})).catch(reason => []);
  }

  getExcel(idreservas: number[], jwt: string, conCargos : boolean): Promise<any> {
    const urlFinal = environment.URL_Excel;
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/json');
    const body = { idreservas, jwt,conCargos };
    return firstValueFrom(this.http.post <Blob> (this.UrlAPI + urlFinal, body, { headers, responseType: 'json' }));
  }

  getVehicles(city: string): Promise<Vehicle[]> {
    return this.initializeLists().then( result => {
      return this.currentVehicles;
    });
  }

  getDrivers(city: string): Promise<Driver[]> {
    return this.initializeLists().then( result => {
      return this.currentDrivers;
    });
  }
}
